import type { Rng } from '../rng';
import type { GameEvent, GameState } from '../types';

/** Contexto de uma ação em andamento: estado em rascunho, RNG e eventos emitidos. */
export interface Ctx {
  s: GameState;
  rng: Rng;
  events: GameEvent[];
}

export class RuleError extends Error {
  constructor(public code: string) {
    super(code);
    this.name = 'RuleError';
  }
}
